import columns from '../../../../react-table/helpers/columns';

export const toggleRowButtonProps = (state, rowInfo) => {
  let className = '';
  if (rowInfo &&
    (!rowInfo.row.receptacleIds || rowInfo.row.receptacleIds.length < 2)) {
    className = 'not-expandable';
  }
  return {
    className,
  };
};

export default (data) => {
  const {
    TextColumn,
    DateTimeColumn,
    NonZeroNumberColumn,
    ToggleRowButtonColumn,
    MultilineExternalReceptacleLinkColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new ToggleRowButtonColumn().withGetProps(toggleRowButtonProps),
        new TextColumn('Device ID', 'deviceId'),
        new DateTimeColumn('Registration time', 'registrationTime'),
        new TextColumn('Handler', 'handler'),
        new DateTimeColumn('Planned departure time', 'plannedDepartureTime'),
        new TextColumn('Carrier', 'carrier'),
        new TextColumn('Conveyance reference', 'conveyanceReference'),
        new TextColumn('Destination', 'destination'),
        new TextColumn('Consignment', 'consignment'),
        new MultilineExternalReceptacleLinkColumn('Label / Receptacle ID', 'receptacleIds').withWidth(300).withExpandable('non-clickable-first-link'),
        new NonZeroNumberColumn('Receptacles', 'receptacles'),
        new TextColumn('Planned departure - Registration date', 'difference'),
      ],
    },
  ];
};
